import axios, {AxiosResponse} from 'axios';
import {handleError} from './errorHandling';
import {SearchtermFromProductIdRequest, SearchtermFromProductIdResponse} from '../types/api/insights/SearchtermFromProductId';
import {ProductsFromSearchtermRequest, ProductsFromSearchtermResponse} from '../types/api/insights/ProductsFromSearchterms';

// tslint:disable-next-line:no-identical-functions
export function searchtermsFromProductId(data: SearchtermFromProductIdRequest): Promise<AxiosResponse<SearchtermFromProductIdResponse[]>> {
    return axios
        .get('sessions/getSessionsFromSearchtermForProductId', {params: data})
        .catch(handleError('error:loadingOfSearchtermsForProductFailed'));
}

// tslint:disable-next-line:no-identical-functions
export function productsFromSearchTerm(data: ProductsFromSearchtermRequest): Promise<AxiosResponse<ProductsFromSearchtermResponse[]>> {
    return axios.get('sessions/getProductsFromSearchterms', {params: data}).catch(handleError('error:loadingOfProductsForSearchtermFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/InsightsAPI.ts